module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h-1":"契約の仕組み","description":"規約の同意後、案件ごとに簡単な個別契約を結ぶだけで全国の倉庫が使えます。\\n倉庫提供者との交渉や契約は、すべてWareXが対応します。"}}')
  delete Component.options._Ctor
}
